import { render, staticRenderFns } from "./SpatialSpanColorSequenceTutorial.vue?vue&type=template&id=4f140f93&scoped=true&"
import script from "./SpatialSpanColorSequenceTutorial.vue?vue&type=script&lang=js&"
export * from "./SpatialSpanColorSequenceTutorial.vue?vue&type=script&lang=js&"
import style0 from "./SpatialSpanColorSequenceTutorial.vue?vue&type=style&index=0&id=4f140f93&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f140f93",
  null
  
)

export default component.exports